<div class="flex" [ngClass]="formControl.errors && formControl.dirty ? 'mb-0' : 'mb-6'">
  <om-select
    [label]="props.label"
    [control]="formControl"
    [placeholder]="props.placeholder"
    [clear]="true"
    [options]="options$ | async"
    [mode]="props.multiple ? 'multiple' : 'default'"
    [searchable]="props.searchable ?? false"></om-select>
</div>
